import { axios, type ConsumablesOrderConfig } from 'shared';

export function getSlackInstallUrl() {
  return axios.get<{ install_url: string }>('v1/customer_admins/slack_install_url');
}

export type TenancySlackInstallationResponse = {
  has_slack_installation: boolean;
  /** `slack://` URL to open this app’s Home tab in the Slack client; null if not installed or app id not configured. */
  app_home_deep_link: string | null;
  /** Bot scopes that the current installation is missing vs. the latest required set. Empty when fully up to date. */
  missing_scopes?: string[];
};

export function getTenancySlackInstallation(tenancyId: number) {
  return axios.get<TenancySlackInstallationResponse>(`v2/tenancies/${tenancyId}/slack_installation`);
}

export type CustomerAdminConsumablesOrderConfigResponse = Pick<ConsumablesOrderConfig, 'max_amount_cents'>;

export function getCustomerAdminConsumablesOrderConfig(tenancyId: number) {
  return axios.get<CustomerAdminConsumablesOrderConfigResponse>(
    `v1/customer_admins/tenancies/${tenancyId}/consumables_order_config`
  );
}

export function updateCustomerAdminConsumablesOrderConfig(tenancyId: number, payload: { max_amount_cents: number }) {
  return axios.patch<CustomerAdminConsumablesOrderConfigResponse>(
    `v1/customer_admins/tenancies/${tenancyId}/consumables_order_config`,
    { consumables_order_config: payload }
  );
}
